import { getMusciList } from '@/request/api/home.js';
import { onMounted, reactive } from 'vue';
export default {
  name: 'MusicList',

  setup() {
    const state = reactive({
      musiclist: []
    });
    onMounted(async () => {
      let {
        data: res
      } = await getMusciList();
      state.musiclist = res.result;
    });

    const changeCount = num => num >= 100000000 ? (num / 100000000).toFixed(1) + '亿' : (num / 10000).toFixed(1) + '万';

    return {
      state,
      changeCount
    };
  }

};